import React from "react";

const Breadcrumb = ({ breads, changeBreadCrumbs }) => {
  return (
    <div className="flex flex-row gap-2 w-full border-0 border-b-2 border-b-gray-200 bg-white px-5 py-3 font-semibold text-[24px] font-sans text-black">
      {breads.map((v, i) => (
        <div className="flex flex-row gap-2" key={i}>
          <div
            className="hover:underline cursor-pointer"
            onClick={() => changeBreadCrumbs(i)}
          >
            {v}
          </div>
          {i != breads.length - 1 ? <span>{">"}</span> : null}
        </div>
      ))}
    </div>
  );
};

export default Breadcrumb;
